// extracted by mini-css-extract-plugin
export default {"contactMain":"style_contactMain__M+Q8i","contactMage":"style_contactMage__liuBE","line":"style_line__-e4fy","contactForm":"style_contactForm__fvA6b"};